'use client';
import { Popover } from '@base-ui/react/popover';
import { css } from '@repo/pandacss/styled-system/css';
import { useMemo } from 'react';
import { MdHelpOutline } from 'react-icons/md';
import { DisclosureTooltip } from '../../../DisclosureTooltip';
import { productCardDriverTooltipClassName } from '../../../disclosureTooltipPopover';

type Props = {
  driverLabel: string;
  valueTooltip: string;
  tooltipClassName?: string;
};

export function ValueTooltip({
  driverLabel,
  valueTooltip,
  tooltipClassName = productCardDriverTooltipClassName,
}: Props) {
  const handler = useMemo(() => Popover.createHandle<unknown>(), []);

  return (
    <>
      <Popover.Trigger
        handle={handler}
        aria-label={`${driverLabel} info`}
        className={css({
          borderTopWidth: 'none',
          borderRightWidth: 'none',
          borderBottomWidth: 'none',
          borderLeftWidth: 'none',
          borderTopStyle: 'none',
          borderRightStyle: 'none',
          borderBottomStyle: 'none',
          borderLeftStyle: 'none',
          backgroundColor: 'transparent',
          paddingTop: '0',
          paddingRight: '0',
          paddingBottom: '0',
          paddingLeft: '0',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          color: 'neutral.black',
        })}
      >
        <MdHelpOutline />
      </Popover.Trigger>
      <DisclosureTooltip handler={handler} tooltipClassName={tooltipClassName}>
        <span className={css({ textStyle: 'textSmall' })}>{valueTooltip}</span>
      </DisclosureTooltip>
    </>
  );
}
